export const URL_PATTERN = /^(https?:\/\/|www)\S+\.[a-zA-Z]{2,6}(\/[^\s%]*)?(\/[\w.%-]*)*$/;
export const IP_PATTERN = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
